/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react'

import PropTypes from 'prop-types'

import styleNames from '@pareto-engineering/bem/exports'

import { Link } from 'react-router-dom'
import { Button } from '@pareto-engineering/design-system'
import { useBlog } from '../Context'
import './styles.scss'

// Local Definitions

const baseClassName = styleNames.base

const componentClassName = 'paginator'

/**
 * This is the component description.
 */
const Paginator = ({
  id,
  className:userClassName,
  style,
  pageNumber,
  hasNextPage,
  category,
  buttonColor,
}) => {
  const {
    generateBlogPath,
  } = useBlog()

  const paginatedSuffix = (pageNumber - 1) > 1 ? '_PAGINATED' : ''
  const blogPathKey = category ? `LIST_CATEGORY${paginatedSuffix}` : `LIST${paginatedSuffix}`

  return (
    <div
      id={id}
      className={[
        baseClassName,
        componentClassName,
        userClassName,
      ]
        .filter((e) => e)
        .join(' ')}
      style={style}
      // {...otherProps}
    >
      { (pageNumber > 1)
        ? (
          <Link to={generateBlogPath(
            blogPathKey,
            {
              pageNumber:pageNumber - 1,
              category,
            },
          )}
          >
            <Button
              isSimple
              color={buttonColor}
              isCompact
              arrowDirection="left"
            >
              Newer
            </Button>
          </Link>
        )
        : <span />}
      { hasNextPage
        ? (
          <Link to={generateBlogPath(
            category ? 'LIST_CATEGORY_PAGINATED' : 'LIST_PAGINATED',
            {
              pageNumber:pageNumber + 1,
              category,
            },
          )}
          >
            <Button
              isSimple
              color={buttonColor}
              isCompact
              arrowDirection="right"
            >
              Older
            </Button>
          </Link>
        )
        : <span />}
    </div>
  )
}

Paginator.propTypes = {
  /**
   * The HTML id for this element
   */
  id:PropTypes.string,

  /**
   * The HTML class names for this element
   */
  className:PropTypes.string,

  /**
   * The React-written, css properties for this element.
   */
  style:PropTypes.objectOf(PropTypes.string),

  /**
   * The current page number
   */
  pageNumber:PropTypes.number.isRequired,

  /**
   * Whether there is a next page
   */
  hasNextPage:PropTypes.bool,

  /**
   * If the page displays category-filtered articles, the current category slug
   */
  category:PropTypes.string,

  /**
   * The button color
   */
  buttonColor:PropTypes.string,
}

Paginator.defaultProps = {
  buttonColor:'heading',
}

export default Paginator
